import { lazy } from 'react';

export const StripecheckoutPage = lazy(() => import('./page-list'));
